import store from '@/store/index'
import * as qiniu from 'qiniu-js'
import URLConfig from '../config/URLConfig'
import _axios from './_axios'
import Router from '@/router'
import $ from 'jquery'
import { UploadImages } from '@/assets/utils/uploadFiles'

let isDev = process.env.NODE_ENV === 'development'

//判断一个元素是否存在一个数组中
export const isInArray = (arr, value) => {
  arr = arr || []//防止传入的不是数组，取length报错
  for (let i = 0; i < arr.length; i++) {
    if (value == arr[i]) return true
  }
  return false
}
/*判断是否有相应的展示权限*/
export const powerIsInArray = (targetArr) => {
  let flag = false
  let powers = store.state.userLoginMessage.power_id_arr
  for (let i = 0; i < targetArr.length; i++) {
    let item = targetArr[i]
    if (isInArray(powers, item)) {
      flag = true
      break
    }
  }
  return flag
}
//字符串长度截断函数
export const formatString = (len, str) => {
  if (!len) return str;    //如果没传长度，则原样返回
  if (!str) return str;    //如果字符串不存在或者为假，也原样返回
  let strLen = str.length;
  if (strLen <= len) return str;
  else return str.slice(0, len) + '...';
}
//判断手机号是否正确
export const isPhone = (value) => {
  if (!value) return false;
  return value.length === 11 && (/^[1][3456789]\d{9}$/.test(value))
}

//判断姓名是汉字和字母
export const isName = (value) => {
  if (!value) return false;
  return (/^[\u4e00-\u9fa5A-Za-z]{1,16}$/.test(value))
}

//导游姓名只能是中文
export const guideName = (value) => {
  if (!value) return false;
  return (/^[\u4e00-\u9fa5]{1,6}$/.test(value))
}

//判断身份证号是否存在
export const isIDexist = value => {
  if (!value) return false;
  return (/^[1-9]\d{5}(([1][9]\d{2})|([2][0][0]\d{1})|([2][0][1]\d{1}))([0][1-9]|[1][012])([0][1-9]|[12][0-9]|[3][01])(\d{4}|\d{3}[X])$/.test(value))
}
//判断输入的金额是否正确
export const isMoneyRight = value => {
  if (!value) return false;
  return /^(0.[1-9]{1}|0.[1-9]{1}[0-9]{1}|0.[0-9]{1}[1-9]{1}|[1-9]+\d*(.\d{1,2})?)$/.test(value)
}
//判断是否为正整数
export const isPositiveInteger = value => {
  if (!value) return false;
  return /^[0-9]+$/.test(value);
}
//大于0的两位小数或整数
export const isFloatInteger = value => {
  if (!value) return false;
  return /^((0\.(0[1-9]|[1-9]\d?))|([1-9]\d{0,6}(\.\d{1,2})?))$/.test(value);
}
//判断邮箱号是否正确
export const isEmail = value => {
  if (!value) return false;
  return /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/.test(value);
}
//判断固定电话是否正确
export const isFixTel = value => {
  if (!value) return false;
  // return /^(([0]{1}\d{2,3}-\d{6,8})|([0]{1}\d{2,3}-\d{6,8}-\d{1,6}))$/.test(value);
  return /^(([1][3-9]\d{9})|([0]\d{2,3}-\d{6,8}(-\d{1,6})?)|(400\d{7})|(400-\d{3,4}-\d{3,4}))$/.test(value);
}
//判断日期是周几
export const getMyDay = (time) => {
  let date = null
  date = time ? new Date(time) : new Date()
  let week;
  if (date.getDay() == 0) week = '周日'
  if (date.getDay() == 1) week = '周一'
  if (date.getDay() == 2) week = '周二'
  if (date.getDay() == 3) week = '周三'
  if (date.getDay() == 4) week = '周四'
  if (date.getDay() == 5) week = '周五'
  if (date.getDay() == 6) week = '周六'
  return week;
};
//根据订单状态返回文字色值
export const FormatColor = status => {
  let dangerArr = ['10', '97', '98', '99','100']
  let successArr = [ '6', '9']
  if (status == 0) return 'text-red';
  if (status == 1) return 'text-red';
  if (status == 3) return 'text-blue';
  if (status == 8 || status == 2|| status == 7) return 'text-green';
  if (isInArray(dangerArr, status)) return 'text-muted'
  if (isInArray(successArr, status)) {
    return 'text-success'
  } else {
    return 'text-blue'
  }
}
//根据用户身份返回文字颜色
export const userColor = type => {
  let arr = {
    2:'text-info',
    3:'text-blue',
    4:'text-warning',
    5:'text-danger',
    6:'text-success',
    8:'text-purple'
  }
  return arr[Number(type)];
}
//根据关联状态返回文字颜色
export const correlationColor = type => {
  let arr = {
    1:'text-purple',
    2:'text-success',
    3:'text-danger',
    4:'text-success',
    5:'text-success',
  }
  return arr[Number(type)];
}
/**
 * 功能：拼接图片地址
 * @param src：七牛云、base64图片地址
 * @param w：想要设置的图片展示宽
 * @param h：想要设置的图片展示高
 * @returns {string}：base64直接返回，七牛云地址拼接并加上宽高返回
 */
export const formatImgSrc = (src, w, h) => {
  if (!src) return '';
  if (src.indexOf(';base64') !== -1) return src;      //base64格式的图片
  if (src.indexOf(URLConfig.QINIU_URL) !== -1) {       //带前缀的七牛云图片地址

    let reg2 =  new RegExp('('+URLConfig.QINIU_URL+')+','g')
    src=src.replace(reg2,URLConfig.QINIU_URL)

    if (w > 0 && h > 0) {
      return src + '?imageView2/1/w/' + w + '/h/' + h;
    } else return src;
  } else {                                            //不带前缀的七牛云图片地址
    if (w > 0 && h > 0) {
      return URLConfig.QINIU_URL + src + '?imageView2/1/w/' + w + '/h/' + h;
    } else return URLConfig.QINIU_URL + src;
  }
}
export const formatAddress = (province, city, block, address) => {
  return province + (city === province ? '' : city) + block + (address || '')
}

/**
 * 计算某一时间戳距今的时间差
 * @param timestamp   传入待计算的时间戳
 * @param diffVal     相隔的时间,默认计算12小时
 * @returns {string}
 */
export const getTimeDiff = (timestamp, diffVal) => {
  let timestampNow = Date.parse(new Date())              //获取当前时间的时间戳，单位为毫秒
  let newDiffVal = diffVal || 86400-1;
  let timeDiff = (timestamp + newDiffVal) - timestampNow / 1000    //剩余时间+12小时 - 当前时间戳/1000
  if (timeDiff <= 0) {
    return '订单过期已失效'
  }
  let days = Math.floor(timeDiff / 86400);
  let remain = timeDiff % 86400
  let hours = Math.floor(remain/ 3600);                 //相差的秒数除以3600（一小时的秒数）向左取整，计算出小时数
  let leave1 = timeDiff % (60 * 60)                          //计算小时数后剩余的秒数
  let minutes = Math.floor(leave1 / 60)                    //计算相差的分钟数
  let seconds = leave1 % (60)                              //计算分钟后剩余的秒数

  hours = hours < 10 ? '0' + hours : hours
  minutes = minutes < 10 ? '0' + minutes : minutes
  seconds = seconds < 10 ? '0' + seconds : seconds
  return (Number(days) > 0 ? days + '天' : '')+(Number(hours) > 0 ? hours + '时' : '')+ minutes + '分' + seconds + '秒';
}
// 时间范围
export const getYearAndMonthAndDay = (start,end) => {
  let dateAll = [],i = 0;
  let startTime = getDate(start)
  let endTime = getDate(end)
  while ((endTime.getTime() - startTime.getTime()) >= 0) {
    let year = startTime.getFullYear();
    let month = (startTime.getMonth() + 1).toString().length == 1 ? '0' + (startTime.getMonth() + 1).toString() : (startTime.getMonth() + 1).toString();
    let day = startTime.getDate().toString().length == 1 ? '0' + startTime.getDate() : startTime.getDate();
    dateAll[i] = year + '-' + month + '-' + day;
    startTime.setDate(startTime.getDate() + 1);
    i += 1;
  }
  dateAll.pop()
  return dateAll;
}
export const getDate = (datestr) => {
  let temp = datestr.split('-');
  if (temp[1] === '01') {
      temp[0] = parseInt(temp[0],10) - 1;
      temp[1] = '12';
  } else {
      temp[1] = parseInt(temp[1],10) - 1;
  }
  //new Date()的月份入参实际都是当前值-1
  let date = new Date(temp[0], temp[1], temp[2]);
  return date;
}
/*截流函数*/
export const damControl = (fn, delay) => {
  let timer = null
  return () => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      fn()
    }, delay)
  }
}
/*函数防抖*/
export const debouncer = (fn, delay) => {
  let begin = new Date()
  return () => {
    let current = new Date()
    if (current - begin >= delay) {
      fn()
      begin = current
    }
  }
}
/*生成支付二维码*/
export const producePayQRCode = (data) => {
  let token = store.state.userLoginMessage.token;
  let count = new Date().getTime();
  let url = isDev ? URLConfig.DEV_API : URLConfig.API_URL;
  let {hotelId,orderId,priceFen,orderPayId,type} = data;
  return `${url}/pc/Common/getPayQrcode?needToken=${token}&needType=1&version=${window.localStorage.getItem('VERSION')}&hotel_id=${hotelId}&oid=${orderId}&price_fen=${priceFen}&order_pay_id=${orderPayId}&source=1&order_pay_type=${type}&count=${count}`;
}

/**
 * 上传文件到七牛云
 * @param file        要上传的文件
 * @returns 返回一个 subscription 对象，该对象有一个 unsubscribe 方法取消订阅，同时终止上传行为
 */
export const UploadFileToQiniu = async (file) => {
  //设置保存文件的名字格式
  let name = file.name ? file.name : '.png';
  let key = '_fcw' + new Date().getTime() + name;
  let config = {
    useCdnDomain: true,      //表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false
    checkByMD5: true,         //是否开启 MD5 校验，为布尔值,在断点续传是比对已上传的分片是否正确
  };
  let putExtra = {
    fname: '',                //文件原文件名
    params: {},               //用来放置自定义变量
    mimeType: null            //用来限制上传文件类型，为 null 时表示不对文件类型限制
  };
  let token = await _axios.post('/pc/AuthAndBind/GetQiNiuToken', {})
  token = token.data.token;     //上传视频token
  return qiniu.upload(file,key,token,putExtra,config);
}
//页码跳转
export const pageChange = v => {
  let name = Router.currentRoute.name,
      query = Router.currentRoute.query;
  Router.push({name,query:{...query,page:v}})
}
//获取浏览器类型
export const getBrowserInfo = () => {
  let Sys = {};
  let ua = navigator.userAgent.toLowerCase();
  let re = /(msie|firefox|chrome|opera|version).*?([\d.]+)/;
  let m = ua.match(re);
  Sys.browser = m[1].replace(/version/, "'safari");
  Sys.ver = m[2];
  return Sys;
}
//整理富文本编辑器中的图片并上传
export const formatEditor = async (text) => {
  if (!text) return '';
  try {
    let domEl = $(text);
    let imgs = domEl.find('img'),
      len = imgs.length,
      path,
      formatText = '';
    for (let i = 0; i < len; i++) {
      path = (await UploadImages(imgs[i].src))[0];
      $(imgs[i]).attr('src',URLConfig.QINIU_URL + path);
    }
    domEl.each((i,v) => {
      formatText += v.outerHTML;
    })
    return formatText;
  } catch (e) {
    return text
  }
}
// 数据分类归组
export const classFiy = async (arr,type) => {
  let newArr = [];
  arr.forEach((item) => {
    let index = -1;
    let alreadyExists = newArr.some((newAddress, j) => {
        if (item[type] === newAddress[type]) {
          index = j;
          return true;
        }
    });
    if (!alreadyExists) {
        newArr.push({
          [type]: item[type],
          arr: [item]
        });
    } else {
        newArr[index].arr.push(item);
    }
  });
  return newArr;
}
export const  verifyDigitThree=(value,num) =>  {   
        let decimal= num||3; 
        // 限制只能有一个小数点
        value = value.replace(/[^\d.]/g, '');
        const dotIndex = value.indexOf('.');
        if (dotIndex !== -1) {
            value = value.substring(0, dotIndex + 1) + value.substring(dotIndex + 1).replace(/\./g, '');
        }
        
        // 限制格式为0.xxx
        if (value.startsWith('0') && value.length > 1 && value[1] !== '.') {
            value = '0.' + value.substring(1);
        }
        
        // 限制最大输入长度和精度
        if (dotIndex !== -1 && value.length > dotIndex + decimal) {
            value = value.substring(0, dotIndex + decimal);
        }
        return value
}